import { apiGet } from 'tennders-stracture/libs/api'
import { useEffect, useState } from 'react'

type Props = {
  transactionId ?: number,
  modalProps?: any
}
const useMarketplace = ({ transactionId, modalProps }:Props) => {
  const [loading, setLoading] = useState(false)
  const [marketplaceCompanies, setMarketplaceCompanies] = useState([])
  const [form, setForm] = useState({})
  const [localShared, setLocalShared] = useState({ })
  const [isPublic, setIsPublic] = useState(false)

  const onChange = (k, v) => setForm({ ...form, [k]: v })

  const onCompanyChange = (key, checked) => {
    const id = key.replace(/companies_/, '')
    const f = { ...form }
    const localForm = { ...localShared }
    f[`companies_${id}`] = checked
    const company = marketplaceCompanies.filter((carrier) => carrier?.company_id === id)[0]
    company?.users?.forEach((user) => {
      f[`carriers_${user?.user_id}`] = checked
      localForm[`carriers_${user?.user_id}`] = checked
    })
    setForm(f)
    setLocalShared(localForm)
  }

  const onUserChange = (key, value) => {
    onChange(key, value)
    const localForm = { ...localShared }
    localForm[key] = value
    setLocalShared(localForm)
  }

  /*
    * Loads carrier companies from marketplace and their network users
    * */
  const loadMarketplaceCompanies = async () => {
    setLoading(true)

    const sharedWith = transactionId ? await apiGet(`/market-place/${transactionId}/sharedWith`) : null
    const response = await apiGet('market-place/companies')
    if (response && Array.isArray(response)) {
      setMarketplaceCompanies(response)
    }
    const f = { ...form }
    response.forEach((carrier) => {
      carrier?.users?.forEach((user) => {
        if (sharedWith && Array.isArray(sharedWith) && sharedWith.indexOf(user?.user_id) > -1) {
          f[`companies_${carrier.company_id}`] = true
          f[`carriers_${user.user_id}`] = true
        }
      })
    })
    setForm(f)
    setLoading(false)
  }

  const shareAsPublic = () => {
    if (isPublic) {
      setForm({})
      setIsPublic(false)
    } else {
      const f = { ...form }

      marketplaceCompanies.forEach((carrier) => {
        f[`companies_${carrier.company_id}`] = true
        carrier?.users?.forEach((user) => {
          f[`carriers_${user.user_id}`] = true
        })
      })
      setForm(f)
      setIsPublic(true)
    }
  }

  useEffect(() => {
    if (modalProps) {
      loadMarketplaceCompanies()
    }
  }, [transactionId, modalProps])

  return {
    marketplaceCompanies,
    loadMarketplaceCompanies,
    mpCompaniesLoading: loading,
    onMpCompanyChange: onCompanyChange,
    onMpUserChange: onUserChange,
    mpForm: form,
    setMpForm: setForm,
    shareAsPublic,
    isPublic
  }
}

export default useMarketplace
